import { render, staticRenderFns } from "./VaJsonInput.vue?vue&type=template&id=874e8cf6&scoped=true&"
import script from "./VaJsonInput.vue?vue&type=script&lang=js&"
export * from "./VaJsonInput.vue?vue&type=script&lang=js&"
import style0 from "./VaJsonInput.vue?vue&type=style&index=0&id=874e8cf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874e8cf6",
  null
  
)

export default component.exports